import { create } from 'zustand';
import { CoMarketingAssets } from '@/types';
import { log, utils } from '@/helpers';
import { safeFetchAPI } from '@/api';

export interface CoMarketingAssetsStoreState {
	loaded: boolean;
	loading: boolean;
	coMarketingAssets?: CoMarketingAssets;
}

interface CoMarketingAssetsStoreActions {
	fetchCoMarketingAssets: (templateID: number, args: GetCoMarketingTemplateAssetsArgs) => Promise<CoMarketingAssets | undefined>;
}

export type CoMarketingAssetsStore = CoMarketingAssetsStoreState & CoMarketingAssetsStoreActions;

const initialState: CoMarketingAssetsStoreState = {
	loaded: false,
	loading: false,
	coMarketingAssets: undefined,
};

export const useCoMarketingAssetsStore = create<CoMarketingAssetsStore>((set, get) => ({
	...initialState,

	fetchCoMarketingAssets: async (templateID: number, args: GetCoMarketingTemplateAssetsArgs) => {
		set({ loading: true });
		const [assets, error] = await safeFetchAPI<CoMarketingAssets>(`/co-marketing/assets/:uid/${templateID}`, {
			method: 'POST',
			payload: {
				...args,
			},
		});

		if (error) {
			log('error', error);
			utils?.toaster?.addToast?.({
				message: error || 'Error fetching co-marketing assets',
				type: 'danger',
			});
			set({ loading: false });
			return;
		}

		log('co-marketing assets', assets);

		set({ coMarketingAssets: assets, loaded: true, loading: false });
		return assets;
	},
}));

type GetCoMarketingTemplateAssetsArgs = {
	campaignOnly?: boolean;
	specificAudiences?: Record<string, boolean>;
	specificSurveys?: Record<string, boolean>;
	specificSignUpForms?: Record<string, boolean>;
};
